import { createContext, useContext, useState } from 'react'

const ticketInitialDataContext = createContext<{
  areaId: string | undefined
  subareaId: string | undefined
  patientId: string | undefined
  description: string | undefined
  setInitialData: (data: {
    areaId?: string
    subareaId?: string
    patientId?: string
    description?: string
  }) => void
}>({
  areaId: '',
  subareaId: '',
  patientId: '',
  description: '',
  setInitialData: () => {}
})

export const useTicketInitialDataContext = () =>
  useContext(ticketInitialDataContext)

export default function TicketInitialDataContext({
  children
}: {
  children: React.ReactNode
}) {
  const [areaId, setAreaId] = useState<string>()
  const [subareaId, setSubareaId] = useState<string>()
  const [patientId, setPatientId] = useState<string>()
  const [description, setDescription] = useState<string>()

  return (
    <ticketInitialDataContext.Provider
      value={{
        areaId,
        subareaId,
        patientId,
        description,

        setInitialData({
          areaId,
          subareaId,
          patientId,
          description
        }: {
          areaId?: string
          subareaId?: string
          patientId?: string
          description?: string
        }) {
          setAreaId(areaId)
          setSubareaId(subareaId)
          setPatientId(patientId)
          setDescription(description)
        }
      }}
    >
      {children}
    </ticketInitialDataContext.Provider>
  )
}
